import { ArrowRight, ArrowUpRight } from "lucide-react";
import { BUSINESSES } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";
import { scrollToSection } from "@/lib/scroll";

const CardInner = ({ item }) => (
  <>
    <div className="flex items-start justify-between gap-6">
      <span className="font-mono text-[11px] tracking-[0.28em] text-aqua">
        {item.index}
      </span>
      <span className="h-px w-16 bg-border transition-all duration-500 group-hover:w-24 group-hover:bg-aqua/60" />
    </div>

    <h3 className="mt-10 text-xl font-semibold uppercase tracking-[0.04em] text-offwhite sm:text-2xl">
      {item.name}
    </h3>
    <p className="label-mono mt-3 text-mist">{item.category}</p>
    <p className="mt-6 max-w-md text-sm leading-relaxed text-mist/90">
      {item.description}
    </p>

    <span className="label-mono mt-10 inline-flex items-center gap-2 text-offwhite">
      <span className="aqua-underline pb-1">{item.cta}</span>
      {item.external ? (
        <ArrowUpRight className="h-3.5 w-3.5 text-aqua transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      ) : (
        <ArrowRight className="h-3.5 w-3.5 text-aqua transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </span>
  </>
);

const cardClass =
  "group relative flex h-full flex-col overflow-hidden border border-border bg-[linear-gradient(155deg,hsl(var(--navy-800)/0.75),hsl(var(--navy-950)/0.9))] p-8 text-left transition-all duration-500 hover:-translate-y-1 hover:border-aqua/45 hover:shadow-[0_24px_60px_-40px_hsl(var(--aqua))] sm:p-10";

export const Businesses = () => (
  <section
    id="businesses"
    data-testid="businesses-section"
    className="relative border-t border-border/70 bg-navy-900/40 py-24 lg:py-36"
  >
    <div className="shell">
      <SectionHeading eyebrow={BUSINESSES.eyebrow} lines={BUSINESSES.headline} />

      <div className="mt-16 grid gap-px bg-border/60 sm:grid-cols-2 lg:mt-20">
        {BUSINESSES.items.map((item, i) => (
          <Reveal key={item.name} delay={0.07 * i} className="h-full">
            {item.external ? (
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`business-card-${item.testId}`}
                className={cardClass}
              >
                <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(100%_70%_at_0%_0%,hsl(var(--aqua)/0.1),transparent)]" />
                <CardInner item={item} />
              </a>
            ) : (
              <button
                type="button"
                onClick={() => scrollToSection(item.target)}
                data-testid={`business-card-${item.testId}`}
                className={cardClass}
              >
                <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(100%_70%_at_0%_0%,hsl(var(--aqua)/0.1),transparent)]" />
                <CardInner item={item} />
              </button>
            )}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
